import React, { useEffect, useState,useContext } from 'react';
import EditTabs from '../../Components/Enhancement/RepresentativeEdit/EditTabs';
import { AuthContext } from '../../Components/Auth/AuthContext';
import { useParams } from 'react-router-dom';

const EditUser = () => {
  const { id } = useParams(); 
  const [data, setData] = useState(null);
  const [repId,setRepId] = useState(id)
  const { isAuthenticated ,isAdmin,uid} = useContext(AuthContext)

  useEffect(()=>{
    const representativeID=window.location.href.split('/').pop()
    setRepId(representativeID)
     
  },[])

  useEffect(()=>{
    if(uid!='' && !isAdmin){
      // console.log("setting uid inside edit user file")
      // setRepId(uid)
      // console.log("uid",uid)
    }

  },[uid])

  return (
    <div style={{background:'#E6E6E6',padding:'1%'}}>
        <EditTabs repId={repId} setRepId={setRepId} isAdmin={isAdmin} />  
    </div>
  );
};

export default EditUser;


